import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export type UnitSystem = 'Metric' | 'Imperial';

export type LocationGeneralPreferencesData = {
  dateFormat: string;
  weekStartDay: string;
  language: string;
  timezone: string;
  currency: string;
  allowedUnitSystems: UnitSystem[];
  defaultUnitSystem: UnitSystem;
};

export const locationGeneralPreferencesQueryAtom = createQueryAtomFactory(
  'settings.locationGeneralPreferences',
  (params: { facilityId: string }) => ({
    facilityGeneralPreferences: {
      __args: { facilityId: params.facilityId },
      dateFormat: true,
      weekStartDay: true,
      language: true,
      timezone: true,
      currency: true,
      allowedUnitSystems: true,
      defaultUnitSystem: true,
    },
  }),
  {
    select: (data): LocationGeneralPreferencesData | null =>
      data.facilityGeneralPreferences,
  },
);
